
const gameConfig = {

    // 制限時間(単位：秒)
    time: 30,

    // 出題アイテム
    items: [
        {key:'apple', frame:0}, 
        {key:'banana', frame:1}, 
        {key:'lemon', frame:2}, 
        {key:'grapes', frame:3}, 
        {key:'cherries', frame:4},
        {key:'kiwi', frame:5}, 
        {key:'melon', frame:6}, 
        {key:'peach', frame:7}, 
        {key:'strawberry', frame:8}, 
        {key:'mango', frame:9},
    ],

    // 配置する数
    num: 10,

    // タマゴの配置座標
    pos: [
        {x:250, y:280}, {x:455, y:256}, {x:655, y:344}, {x:855, y:240}, {x:1050, y:320},
        {x:245, y:540}, {x:460, y:540}, {x:670, y:600}, {x:865, y:510}, {x:1075, y:580},
    ],

    // GETの際に加算になるポイント
    point: 50,

    // 重なっていると判定する割合
    hitThreshold: 0.6,
}

export default gameConfig;